import { mutationTypes } from '@/core/constants'

export default {
    [mutationTypes.AJUSTE.SET_FILTROS_BUSCA_TODOS_AJUSTES](state, filtros) {
        state.todosAjustes.filtros = filtros
    },

    [mutationTypes.AJUSTE.SET_PAGINACAO_BUSCA_TODOS_AJUSTES](state, paginacao) {
        state.todosAjustes.paginacao = paginacao
    },

    [mutationTypes.AJUSTE.SET_AJUSTE](state, ajuste) {
        state.ajuste = ajuste
    },
}
